/**
 * fingerprint.js — a stable-ish device id for trial anti-abuse.
 *
 * Derived from durable browser/device traits (so clearing localStorage does NOT
 * mint a new identity) and cached. Not cryptographically strong — just enough to
 * stop the same machine farming free trials across many accounts. Combined with
 * the signup IP server-side.
 */
function djb2(str) {
  let h = 5381;
  for (let i = 0; i < str.length; i++) h = ((h << 5) + h + str.charCodeAt(i)) >>> 0;
  return h.toString(36);
}

export function getFingerprint() {
  try {
    const traits = [
      navigator.userAgent,
      navigator.language,
      (navigator.languages || []).join(','),
      `${screen.width}x${screen.height}x${screen.colorDepth}`,
      Intl.DateTimeFormat().resolvedOptions().timeZone,
      navigator.hardwareConcurrency,
      navigator.deviceMemory,
      navigator.platform,
    ].join('|');
    const fp = 'fp_' + djb2(traits);
    try { localStorage.setItem('quantum_fp', fp); } catch (_) {}
    return fp;
  } catch (_) {
    try { return localStorage.getItem('quantum_fp') || null; } catch { return null; }
  }
}
